// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Kr-z","imageAndVideoCount":"Lr-z","imageAndVideoContainer":"Mr-z","viewAllReviews":"Nr-z"};